import { render, staticRenderFns } from "./authRes.vue?vue&type=template&id=5aec45bc&scoped=true&"
import script from "./authRes.vue?vue&type=script&lang=js&"
export * from "./authRes.vue?vue&type=script&lang=js&"
import style0 from "./authRes.vue?vue&type=style&index=0&id=5aec45bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec45bc",
  null
  
)

export default component.exports